const ITEMS = [
  "Corporate Films",
  "Nonprofit Fundraising",
  "Podcast Production",
  "Video Courses",
  "Brand Storytelling",
  "Documentary",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-[#1a1a1a] py-8 md:py-10 overflow-hidden bg-[#050505]"
    >
      <div className="marquee-track">
        {row.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-10 md:gap-16 pr-10 md:pr-16 whitespace-nowrap"
          >
            <span
              className={`font-display uppercase text-[42px] md:text-[68px] lg:text-[84px] leading-none ${
                i % 2 === 0 ? "text-white" : "text-outline-red"
              }`}
            >
              {item}
            </span>
            <span className="text-[#E60000] text-4xl md:text-6xl leading-none">
              ✦
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
